// auth.js
export const RECEIVE_SETUSER = 'RECEIVE_SETUSER'
export const RECEIVE_SETJWTTOKEN = 'RECEIVE_SETJWTTOKEN'
export const RECEIVE_SETUPDATESUB = 'RECEIVE_SETUPDATESUB'
export const RECEIVE_SETERROR = 'RECEIVE_SETERROR'
export const RECEIVE_SETUPDATEMAIL = 'RECEIVE_SETUPDATEMAIL'

// report.js
export const RECEIVE_SETREPORT = 'RECEIVE_SETREPORT'

// deliveryMonth.js
export const RECEIVE_COMMON_SELECT_DELIVERY_MONTH = 'RECEIVE_COMMON_SELECT_DELIVERY_MONTH'

// digestive.js
export const RECEIVE_SETDIGESTIVE = 'RECEIVE_SETDIGESTIVE'

// campaignDeliveryStatus.js
export const RECEIVE_SETCAMPAIGNIDS = 'RECEIVE_SETCAMPAIGNIDS'

// landing.js
export const RECEIVE_LANDINGLIST = 'RECEIVE_LANDINGLIST'

// creativeSetting.js
export const RECEIVE_CREATIVE_SETTING = 'RECEIVE_CREATIVE_SETTING'
